import "./NewJersey.css";
import newJerseyMap from "../../images/newjersey.jpg";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export default function NewJerseyMap() {
  const navigate = useNavigate();

  // ⭐ Only one pin for now: Cape May
  const pins = [
    { 
      name: "Cape May", 
      top: "87%",     
      left: "47%",    
      path: "/travel/capemay" 
    },
  
  ];

  const cycleRef = useRef(null);
  const indexRef = useRef(0);
  const pausedRef = useRef(false);
  const timeoutRef = useRef(null);

  const [activePin, setActivePin] = useState(null);

  // ⭐ Load last index on mount
  useEffect(() => {
    const savedIndex = localStorage.getItem("newJerseyMapIndex");
    if (savedIndex !== null) {
      indexRef.current = parseInt(savedIndex, 10);
    }
  }, []);

  // ⭐ Auto-cycle (desktop + mobile)
  useEffect(() => {
    const pinNodes = document.querySelectorAll(".newjersey-pin");

    const startCycle = () => {
      cycleRef.current = setInterval(() => {
        if (pausedRef.current) return;

        pinNodes.forEach((p) => p.classList.remove("active"));
        pinNodes[indexRef.current].classList.add("active");

        setActivePin(indexRef.current);

        localStorage.setItem("newJerseyMapIndex", indexRef.current);

        indexRef.current = (indexRef.current + 1) % pins.length;
      }, 2000);
    };

    startCycle();

    return () => clearInterval(cycleRef.current);
  }, [pins.length]);

  // ⭐ Desktop hover
  const handleHover = (index) => {
    pausedRef.current = true;
    setActivePin(index);
  };

  const handleLeave = () => {
    pausedRef.current = false;
  };

  // ⭐ Mobile touch (pause → show tooltip → resume)
  const handleTouch = (index, event) => {
    if (event && activePin !== index) {
      event.preventDefault();
    }

    pausedRef.current = true;
    setActivePin(index);

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      pausedRef.current = false;
    }, 2000);
  };

  // ⭐ Stop cycle + navigate
  const handleNavigate = (path) => {
    pausedRef.current = true;
    clearInterval(cycleRef.current);
    navigate(path);
  };

  return (
    <div className="newjersey-map-container">
      <img src={newJerseyMap} alt="New Jersey Map" className="newjersey-map" />

      {pins.map((pin, index) => (
        <div
          key={index}
          className={`newjersey-pin ${activePin === index ? "active" : ""}`}
          style={{ top: pin.top, left: pin.left }}
          onMouseEnter={() => handleHover(index)}
          onMouseLeave={handleLeave}
          onTouchStart={(e) => handleTouch(index, e)}
          onClick={() => handleNavigate(pin.path)}
        >
          <div
            className="newjersey-tooltip"
            onClick={(e) => {
              e.stopPropagation();
              handleNavigate(pin.path);
            }}
            onTouchStart={(e) => {
              e.stopPropagation();
              handleNavigate(pin.path);
            }}
          >
            {pin.name}
          </div>
        </div>
      ))}
    </div>
  );
}
